import React, { useContext, useRef } from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { SubscriptionPurchaseFTUEContext } from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUEContext';
import SubscriptionPurchaseFTUE from '../../Tier/ftue/SubscriptionPurchaseFTUE/SubscriptionPurchaseFTUE';
import DeviationFullView from '../../DeviationViews/Full';
import DuperbrowsePaddles from '../../Duperbrowse/DuperbrowsePaddles';
import { useDeviationViewContext } from '../../Context';
import SubscriptionLockLitFTUE from '../../Tier/ftue/SubscriptionLockLitFTUE';
import StageContainer from '../_partials/StageContainer';
import StashPaddles from '../_partials/StashPaddles';
import StageBackground from '../../DeviationBackground/StageBackground';
import { useSelector } from 'react-redux';
import { getIsDuperbrowseActive } from '../../Duperbrowse/redux/selectors';
import { useMeasuredStage } from '../hooks/useMeasuredStage';

import s from './DesktopTextualArtStage.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const DesktopTextualArtStage: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  className,
}) => {
  const { isFullscreen, isTheater } = useDeviationViewContext();
  const isDuperbrowseActive = useSelector(getIsDuperbrowseActive);
  const ref = useRef<HTMLDivElement>(null);
  const { containerSize } = useMeasuredStage(ref, !isFullscreen);

  const isSubscriptionPurchaseFTUEBeingShown = !!useContext(
    SubscriptionPurchaseFTUEContext
  );

  if (isFullscreen) {
    return (
      <StageContainer
        ref={ref}
        className={classnames(s['root'], s['fullscreen'], className)}
      >
        <div className={s['scroll-content-wrap']}>
          <StageBackground
            deviation={deviation}
            width={containerSize?.width}
            height={containerSize?.height}
          />
          <DeviationFullView deviation={deviation} />
        </div>
        {(deviation.isPublished || isDuperbrowseActive) && (
          <DuperbrowsePaddles className={s['duperbrowse']} />
        )}
        {!deviation.isPublished && !isDuperbrowseActive && <StashPaddles />}
        <div className={s['fade']} />
      </StageContainer>
    );
  }

  return (
    <StageContainer
      ref={ref}
      className={classnames(s['root'], isTheater && s['theater'], className)}
    >
      <StageBackground
        deviation={deviation}
        width={containerSize?.width}
        height={containerSize?.height}
      />
      <DeviationFullView deviation={deviation} />
      <div className={s['stage-box']}>
        {(deviation.isPublished || isDuperbrowseActive) && (
          <DuperbrowsePaddles className={s['duperbrowse']} />
        )}
        {!deviation.isPublished && !isDuperbrowseActive && <StashPaddles />}
      </div>
      <SubscriptionLockLitFTUE deviation={deviation} />
      {isSubscriptionPurchaseFTUEBeingShown && <SubscriptionPurchaseFTUE />}
    </StageContainer>
  );
};
DesktopTextualArtStage.displayName = 'DesktopTextualArtStage';

export default DesktopTextualArtStage;
